var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"list-header"}},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('CButton',{attrs:{"color":"primary","to":_vm.link},domProps:{"textContent":_vm._s(_vm.linkText)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }